import React from "react";
import {Form, Input, Row, Button} from "antd";
const ModalDeny = props => {
  const {handleDeny, closeModal} = props;
  const [form] = Form.useForm();
  return (
    <div>
      <Form form={form}>
        <Form.Item name={"description"}>
          <Input></Input>
        </Form.Item>
      </Form>
      <Row justify={"end"} style={{marginTop: 12}}>
        <Button
          type="primary"
          onClick={() => {
            handleDeny(form.getFieldValue("description"));
          }}
        >
          Xác nhận
        </Button>
      </Row>
    </div>
  );
};
export default ModalDeny;
